import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import { TicketFormModel } from '../../models/ticket.model';
import { styled } from '@mui/material/styles';
import { Alert, Grid } from '@mui/material';
import { getElementTypes, getSites } from '../../services/autocomplete.service';
import { GREEN_BKG_FORM, GREEN_DARK, MARGIN_PAPER_FORM } from '../../assets/Styles';
import Copyright from '../common/Copyright';
import BasicData from './BasicData';
import Description from './Description';
import { useNotification } from '../../context/NotificationContext';


const CustomPaper = styled(Paper)(({ theme }) => ({
  borderColor: GREEN_DARK,
  marginBottom: MARGIN_PAPER_FORM,
  padding: theme.spacing(2),
  ...theme.typography.body2,
}));

interface HandleFormProps {
  action: string
  handleChange?: (e: any) => void
  handleSelection?: (...args: any[]) => void
  onSubmit: (p: any) => void
  elementForm: any
  setBlockScreen: (p: boolean) => void
  selectedProject: string
}

export default function HandleForm({ 
  action,
  setBlockScreen,
  handleChange,
  handleSelection,
  onSubmit,
  elementForm,
  selectedProject }: HandleFormProps) {
    
  const { showNotification } = useNotification();

  const { handleSubmit } = useForm<TicketFormModel>()
  const [elementTypesList, setElementTypesList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const requiredFields = [
    'name',
    'element_type',
    'site'
  ]

  const initComponent = () => {
    if (action === "create" || action === "edit") {
      setBlockScreen(true)
      Promise.all([
        getElementTypes(selectedProject),
        getSites(selectedProject),
      ]).then(function (result) {
        setElementTypesList(result[0])
        setSitesList(result[1])
        setBlockScreen(false)
      }).catch((error) => {
        showNotification(error.response.data)
        setBlockScreen(false)
      });
    }
  }

  useEffect(initComponent, [action])

  const formValidator = () => {
    return requiredFields.some((key) => !elementForm[key] || Object.keys(elementForm[key]).length === 0)
  }

  return (
    <React.Fragment>
      <Box>
        <Paper
          sx={{
            my: { xs: 5, md: 1 }, p: { xs: 1, md: 2 }, mx: { xs: 0, md: 1 },
            backgroundColor: GREEN_BKG_FORM,
          }}>
          <CustomPaper variant="outlined">
            <BasicData action={action}
              handleChange={handleChange}
              handleSelection={handleSelection}
              elementForm={elementForm}
              elementTypesList={elementTypesList}
              sitesList={sitesList}
            />
          </CustomPaper>

          <CustomPaper variant="outlined">
            <Description
              action={action}
              handleChange={handleChange}
              elementForm={elementForm}
            />
          </CustomPaper>

          <Grid container  rowSpacing={'2vh'} columnSpacing={'2vw'}>
           
           
           
            {(action === 'create' || action === 'edit') && (<>

            <Grid item xs={12} md={4}>
              <Typography variant="caption" fontFamily="Poppins" gutterBottom>
                (*) Campos requeridos
              </Typography>
            </Grid>

            <Grid item xs={12} md={4}>
              <Alert
                sx={{ display: formValidator() ? 'flex' : 'none' }}
                color="error"
                severity="info">
                Hay campos requeridos sin completar
              </Alert>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  style={{ display: '', fontFamily: "Poppins" }}
                  variant="contained"
                  color="success"
                  onClick={handleSubmit(onSubmit)}
                  disabled={formValidator()}
                >
                  Confirmar
                </Button>
              </Box>
            </Grid>
            </>
            )}
          </Grid>
          
        </Paper>
      </Box>
      <Copyright />
    </React.Fragment >
  );
}
